/* esm.sh - detect-node-es@1.1.0 */
import "/node/process.mjs";
export * from "/*detect-node-es@1.1.0/esnext/detect-node-es.mjs";
